import styled, {css} from "styled-components"

import {ButtonRouterLink} from "@irati/ui/src/Link"
import Icon from "@irati/ui/src/Icon"

export const FlexContainer = styled.div`
  ${({theme}) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: ${theme.spacing.one};
    padding: 0;

    ${theme.mediaQueries.minWidthMedia.tablet`
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: ${theme.spacing.three};
      padding: 10px 0 5px;
    `}
  `}
`

export const Image = styled.img`
  ${({theme}) => css`
    width: 60px;
    margin-right: 20px;

    ${theme.mediaQueries.minWidthMedia.tablet`
      width: 80px;
    `}
  `}
`

export const ImageWrapper = styled.div`
  ${({theme}) => css`
    display: flex;
    align-items: center;
    width: 100%;

    ${theme.mediaQueries.minWidthMedia.tablet`
      width: 70%;
    `}
  `}
`

export const ButtonWrapper = styled.div`
  ${({theme}) => css`
    margin-top: 10px;
    width: 100%;

    ${theme.mediaQueries.minWidthMedia.tablet`
      margin-top: 0;
      width: 30%;
    `}
  `}
`

export const StyledButtonRouterLink = styled(ButtonRouterLink)`
  padding: 11px 20px;
  width: 100%;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const InverseGeoPin = styled(Icon)`
  ${({theme}) => css`
    stroke: ${theme.colors.greys.black};
    fill: none;
    margin-right: 10px;
  `}
`
